<template>
    <div class="export-pickup clearfix" style="position: relative">
        <Form ref="dataForm" :model="formData" :labelWidth="100">
            <FormItem :label="$t('erp.b2c.channel_account', { defaultValue: '渠道账号' })" prop="channelId" :rules="required">
                <Select
                    v-model="formData.channelId"
                    :filterable="true"
                    :clearable="true"
                >
                    <Option
                        v-for="(item, index) in getNewAccountIdList"
                        :key="index"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem :label="$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' })" :rules="required" prop="orgWarehousId">
                <Select
                    v-model="formData.orgWarehousId"
                    :filterable="true"
                    :clearable="true"
                >
                    <Option
                        v-for="item in getNewWarehouseIdList"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem
                :label="$t('erp.b2c.latest_time', { defaultValue: '最晚发货时间' })"
                :rules="required"
                prop="lasteShipDate"
            >
                <DatePicker
                    class="width-100per"
                    v-model="formData.lasteShipDate"
                    format="yyyy-MM-dd"
                    type="date"
                ></DatePicker>
            </FormItem>
        </Form>
        <div class="pull-right">
            <Button type="primary" @click="submit">{{$t('global.common.export', { defaultValue: '导出' })}}</Button>
            <Button class="margin-left-15" @click="$emit('on-close')"
                >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button
            >
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpDownAmxl } from "@/service/boss/b2corder";
import { mapState, mapGetters } from "vuex";
export default {
    data() {
        return {
            formData: {},
            loading: false,
        };
    },
    watch: {
        "formData.orgWarehousId": {
            handler(id) {
                if (!id) return;
                console.log(id);
                let warehouseItem = this.getNewWarehouseIdList.filter(
                    (item) => {
                        return item.value == id;
                    }
                )[0];
                console.log(warehouseItem);
                if (!warehouseItem || !warehouseItem.attach)
                    return (this.formData.orgWarehousCode = null);
                this.formData.orgWarehousCode = warehouseItem.attach.item.code;
            },
        },
    },
    computed: {
        ...mapGetters("diction", [
            "getNewWarehouseIdList",
            "getNewAccountIdList",
        ]),
        required() {
            return [
                {
                    required: true,
                    message: this.$t('global.common.required', { defaultValue: "此项不能为空，请填写" }),
                },
            ];
        },
    },
    methods: {
        submit() {
            let flag = true;
            this.$refs.dataForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            let lasteShipDate = this.handleDateFormat(
                this.formData.lasteShipDate,
                "yyyy-mm-dd"
            );
            // this.loading = true;
            // await HttpDownAmxl({
            //     ...this.formData,
            //     lasteShipDate: lasteShipDate
            // }).then(res => {
            //     this.$VMessage.success(res.message);
            //     this.$emit('on-close');
            // }, err => {
            //     this.$VMessage.error(err.message);
            // }).finally(() => {
            //     this.loading = false;
            // });
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/B2cOrder/downloadAmxl",
                { contextId: global.SYSID, ...this.formData, lasteShipDate: lasteShipDate },
                {
                    executor: "request",
                    download: true,
                }
            );
            // this.loading = false;
            // this.$emit('on-close');
        },
    },
};
</script>

<style>
</style>